import { createAction, props } from '@ngrx/store';
import { BadResponseWithError } from '@shared/models/common.interface';

// Fetch all seasons
export const FETCH_SEASONS_REQUEST = '[Seasons] Fetch seasons request';
export const FETCH_SEASONS_SUCCESS = '[Seasons] Fetch seasons success';
export const FETCH_SEASONS_FAILURE = '[Seasons] Fetch seasons failure';

export const fetchSeasonsRequest = createAction(FETCH_SEASONS_REQUEST);
export const fetchSeasonsSuccess = createAction(
    FETCH_SEASONS_SUCCESS,
    props<{ payload: any }>()
);
export const fetchSeasonsFailure = createAction(
    FETCH_SEASONS_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

// Fetch single season
export const FETCH_SEASON_REQUEST = '[Seasons] Fetch season request';
export const FETCH_SEASON_SUCCESS = '[Seasons] Fetch season success';
export const FETCH_SEASON_FAILURE = '[Seasons] Fetch season failure';

export const fetchSeasonRequest = createAction(
    FETCH_SEASON_REQUEST,
    props<{ seasonId: string }>()
);
export const fetchSeasonSuccess = createAction(
    FETCH_SEASON_SUCCESS,
    props<{ payload: any }>()
);
export const fetchSeasonFailure = createAction(
    FETCH_SEASON_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

// Create season
export const CREATE_SEASON_REQUEST = '[Seasons] Create season request';
export const CREATE_SEASON_SUCCESS = '[Seasons] Create season success';
export const CREATE_SEASON_FAILURE = '[Seasons] Create season failure';

export const createSeasonRequest = createAction(
    CREATE_SEASON_REQUEST,
    props<{ seasonId: string; body: any }>()
);
export const createSeasonSuccess = createAction(
    CREATE_SEASON_SUCCESS,
    props<{ payload: any }>()
);
export const createSeasonFailure = createAction(
    CREATE_SEASON_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

// Update season
export const UPDATE_SEASON_REQUEST = '[Seasons] Update season request';
export const UPDATE_SEASON_SUCCESS = '[Seasons] Update season success';
export const UPDATE_SEASON_FAILURE = '[Seasons] Update season failure';
export const UPDATE_SEASON_IMAGE_SUCCESS =
    '[Seasons] Update season image success';
export const updateSeasonRequest = createAction(
    UPDATE_SEASON_REQUEST,
    props<{ seasonId: string; body: any }>()
);
export const updateSeasonSuccess = createAction(
    UPDATE_SEASON_SUCCESS,
    props<{ payload: any }>()
);
export const updateSeasonFailure = createAction(
    UPDATE_SEASON_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

// Delete season
export const DELETE_SEASON_REQUEST = '[Seasons] Delete season request';
export const DELETE_SEASON_SUCCESS = '[Seasons] Delete season success';
export const DELETE_SEASON_FAILURE = '[Seasons] Delete season failure';

export const deleteSeasonRequest = createAction(
    DELETE_SEASON_REQUEST,
    props<{ seasonId: string }>()
);
export const deleteSeasonSuccess = createAction(
    DELETE_SEASON_SUCCESS,
    props<{ seasonId: string }>()
);
export const deleteSeasonFailure = createAction(
    DELETE_SEASON_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

// Levels
export const SAVE_LEVELS_REQUEST = '[Seasons] Save levels request';
export const SAVE_LEVELS_SUCCESS = '[Seasons] Save levels success';
export const SAVE_LEVELS_FAILURE = '[Seasons] Save levels failure';

export const saveLevelsRequest = createAction(
    SAVE_LEVELS_REQUEST,
    props<{ seasonId: string; body: any }>()
);
export const saveLevelsSuccess = createAction(
    SAVE_LEVELS_SUCCESS,
    props<{ payload: any }>()
);
export const saveLevelsFailure = createAction(
    SAVE_LEVELS_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const FETCH_LEVELS_REQUEST = '[Seasons] Fetch levels request';
export const FETCH_LEVELS_SUCCESS = '[Seasons] Fetch levels success';
export const FETCH_LEVELS_FAILURE = '[Seasons] Fetch levels failure';

export const fetchLevelsRequest = createAction(
    FETCH_LEVELS_REQUEST,
    props<{ seasonId: string }>()
);
export const fetchLevelsSuccess = createAction(
    FETCH_LEVELS_SUCCESS,
    props<{ payload: any }>()
);
export const fetchLevelsFailure = createAction(
    FETCH_LEVELS_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

// Rewards
export const SAVE_REWARDS_REQUEST = '[Seasons] Save rewards request';
export const SAVE_REWARDS_SUCCESS = '[Seasons] Save rewards success';
export const SAVE_REWARDS_FAILURE = '[Seasons] Save rewards failure';

export const saveRewardsRequest = createAction(
    SAVE_REWARDS_REQUEST,
    props<{ seasonId: string; body: any }>()
);
export const saveRewardsSuccess = createAction(
    SAVE_REWARDS_SUCCESS,
    props<{ payload: any }>()
);
export const saveRewardsFailure = createAction(
    SAVE_REWARDS_FAILURE,
    props<{ payload: BadResponseWithError }>()
);
